<template>
  <Modal :title="title" name="RESEND_HOST_INVOICE_MODAL">
    <template v-slot:body>
      <v-row>
        <v-col cols="8">
          <h6 class="text-uppercase grey--text">{{ $t('hausefulInvoices.headers.receiver') }}</h6>
          <p class="mb-0 body-2">{{ customerName() }}</p>
        </v-col>
        <v-col cols="4">
          <h6 class="text-uppercase grey--text text-right">{{ $t('hausefulInvoices.headers.total') }}</h6>
          <p class="body-2 text-right mb-0">{{ customerTotal() }}</p>
        </v-col>
      </v-row>

      <HUploading v-if="isHostUserInvoiceLoading" class="my-5" />
      <HUpload @change="resendInvoice" small />
    </template>
  </Modal>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { catalogMonetary } from '@/util/catalog'

import Modal from '@/components/app/Modal'
import HUpload from '@/components/lib/HUpload'
import HUploading from '@/components/app/HUploading'

export default {
  name: 'ModalResendHostInvoice',

  components: {
    Modal,
    HUpload,
    HUploading,
  },

  props: {
    invoice: {
      type: Object,
      required: false,
    },
  },

  computed: {
    ...mapGetters(['isHostUserInvoiceLoading']),
  },

  methods: {
    ...mapMutations(['closeAllModals']),
    ...mapActions(['updateHostUserInvoice']),

    customerName() {
      return this.invoice?.customer?.name ?? '---'
    },

    customerTotal() {
      return this.invoice?.customer?.total ? catalogMonetary(this.invoice?.customer?.total) : '---'
    },

    resendInvoice(file) {
      const invoiceData = {
        invoice_id: this.invoice.invoice_id,
        payment_ids: this.invoice.payment_ids,
        file: file[0],
      }

      this.updateHostUserInvoice(invoiceData)
    },
  },

  data() {
    return {
      title: this.$t('hausefulInvoices.modals.upload.titleUpdate'),
    }
  }
}
</script>
